import React from 'react'
import Pagination from '@mui/material/Pagination';


export default function PaginationCom({ controller, count, setController }) {
  return (
    <Pagination count={Math.ceil(count / controller?.rowsPerPage)} page={controller.page} color="primary" onChange={(event, value) => { setController((pre) => ({ ...pre, page: value })) }} />
  )
}